import React, { useState, useEffect } from 'react';
import "../Layout/Layout.css";
import Navbar from './mudole/navbar';
import ProductList from './productList';
import Foot from './foot';
import LeafParticles from './LeafParticles';
import Chat from './chat';

function Home() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  const [leaves, setLeaves] = useState([]);

  // Tạo ra một số lá ngẫu nhiên khi component mount
  useEffect(() => {
    const numLeaves = 30; // Số lượng lá trong đống
    const newLeaves = Array.from({ length: numLeaves }).map((_, index) => ({
      id: index,
      // Vị trí ngẫu nhiên ở đáy
      left: `${Math.random() * 100}%`,
      bottom: `${Math.random() * 20}px`, // Có thể điều chỉnh chiều cao của đống lá
      // Kích thước ngẫu nhiên
      size: `${Math.random() * 30 + 30}px`, // Lá lớn hơn
      // Góc xoay ngẫu nhiên
      rotate: `${Math.random() * 360}deg`,
      // Thời gian animation ngẫu nhiên để tạo sự khác biệt
      animationDelay: `${Math.random() * 5}s`,
      // Link ảnh lá của bạn
      image: '/imges/yellow.png' // Thay bằng ảnh lá vàng của bạn
    }));
    setLeaves(newLeaves);
  }, []);
  return (
    <body className='Desktop'>
      <Navbar />
      <ProductList />
       <Foot/>
       <LeafParticles/>
       <Chat />
    </body>
  );
};
const Mobile = () => {
  return (
    <body className='Mobile'>
       <Navbar />
       <ProductList />
       <Foot/>
    </body>
  );
};
export default Home;
